import styled, { css } from "styled-components";
import { theme } from "ui/themes";

interface BoxPriceProductContainerProps {
  removeGap?: boolean;
}

interface ViewProps {
  flexDirection?: string;
  notShouldShowOldPrice?: boolean;
}

export const BoxPriceProductContainer = styled.section<BoxPriceProductContainerProps>`
  background: none;

  display: flex;
  flex-direction: column;
  gap: ${({ removeGap }) => (removeGap ? "0" : "0.5rem")};
`;

export const View = styled.div<ViewProps>`
  ${({ notShouldShowOldPrice, flexDirection }) =>
    notShouldShowOldPrice
      ? css`
          width: 100%;
          text-align: end;
        `
      : css`
          display: flex;
          flex-direction: ${flexDirection ?? "row"};
          align-items: center;
        `}
`;

export const Margin4 = styled.div`
  margin-bottom: 4rem;
`;

type DescriptionParcelsProps = {
  fontSizeDescriptionParcels?: string;
  maxWidth?: string;
  isBlackTheme?: boolean;
  fontColor?: string;
};

export const DescriptionParcels = styled.p<DescriptionParcelsProps>`
  font-size: ${({ fontSizeDescriptionParcels }) =>
    fontSizeDescriptionParcels ?? "1.4rem"};
  color: ${({ fontColor }) => fontColor || theme.colors.neutral["999"]};
  font-weight: 500;
  margin-bottom: 0.5rem;
  max-width: ${({ maxWidth }) => maxWidth ?? "100%"};
`;
